import $ from 'jquery'

global.$ = $;
global.jQuery = $;
window.$ = $;

global.bootstrap = window.bootstrap = require('bootstrap')

//import * as Sentry from "@sentry/browser";
//import { BrowserTracing } from "@sentry/tracing";


require('select2');
require('../../../Framework/assets/js/cms-select2');
require('../../../Framework/assets/js/cms-datepicker');
//require('../../../Framework/assets/js/cms-ajax-form');
require('/Project/Framework/assets/js/cms-ajax-form.js');
require('./cms-element-duplicator');
require('../../../Framework/assets/js/cms-form-conditions')
require('../../../Modules/Captcha/assets/js/cms-captcha')
require('../../../Framework/assets/js/cms-password')
require('../../../Project/Modules/Media/assets/media');
require('../../../Project/Modules/Attributes/assets/js/applicant_address')
require('../../../Project/Modules/Attributes/assets/js/attribute_state_city')
require('../../../Project/Modules/Attributes/assets/js/attribute_project_timeframe')
import Masonry from 'masonry-layout'
import {Fancybox} from '@fancyapps/ui'

global.Fancybox = window.Fancybox = Fancybox

Fancybox.bind("[data-fancybox]", {
    // Your custom options
});


$('.competition_list').each(function () {
    var msnry = new Masonry(this, {
        columnWidth: '.grid-sizer',
        itemSelector: '.grid-item',
        // fitWidth: true,
        // gutter: 10
    });
})


$('body').on('click', 'a[data-confirm],button[data-confirm]', function (e) {//a confirm
    var r = confirm($(this).data("confirm"));
    if (r !== true) {
        e.preventDefault();
    } else {
        $(this).trigger('click-confirmed', e);
    }
})

$(".accordion").each(function () {
    $(this).find('[data-bs-toggle="collapse"]').on('click', function (e) {
        setTimeout(function () {
            if ($(e.currentTarget).attr('aria-expanded') !== 'true') {
                history.replaceState({}, "", ' ')
            } else {
                history.replaceState({}, "", $(this).data('bs-target'))
            }
        }.bind(this), 100)
    })

    if (window.location.hash) {
        setTimeout(function () {
            let $accordionCollapse = $(window.location.hash + ".accordion-collapse")

            if ($accordionCollapse.length) {
                bootstrap.Collapse.getOrCreateInstance(
                    $accordionCollapse[0]
                ).show()
            }
        }, 0);
    }
})

$('.competition_list .card, .appdash-accordion .accordion-item .accordion-header').each(function () {
    let $this = $(this);
    let color = $this.data('color');

    if (color.match(/#/gm) === null) {
        color = '#' + color;
    }

    if (color && CSS.supports('color', color)) {
        $this.css('background-color', color);
        $this.css('visibility', 'visible');
    }
});


$('.competition_table .badge').each(function () {
    let $this = $(this);
    let color = $this.data('color');

    if (color && CSS.supports('color', color)) {
        $this.css('background-color', color);
        $this.css('color', color);
    }
});


const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
})


$(document.body).on('change', '.autosubmit', function () {
    $(this).closest('form').submit();
})
$(document.body).on('click', '[data-action="clear-query"]', function () {
    $(this.form).find('[name="query"]').val('');
    this.form.submit()
})

window.checkRulesAgreement = function () {
    $("[name='agree_rules']").each(function () {
        this.checked = true
    })
    Fancybox.close();
}

// $(document).on('click', '#agreeToRules', function(){
//     Fancybox.close();
// });

var $collection = $('h2[id]');
if ($collection.length > 0) {
    $collection.each(function () {
        var $item = $(this);
        var id = $item.attr('id');

        var link = $('a[href="#' + id + '"]');
        $(link).click(function () {
            $('html, body').animate({
                scrollTop: $item.offset().top - 100
            }, 50);
        });

        $(document).on('scroll', function () {
            var id = $item.attr('id');
            var $li = $('a[href="#' + id + '"]').parent().parent();

            if ($item.isInViewport() || $(this).scrollTop() >= $($item).position().top) {
                if (!$li.hasClass('check')) {
                    $li.addClass('check');
                    updateTabCount();
                }
            } else {
                $li.removeClass('check');
                updateTabCount();
            }

            if ($(window).scrollTop() === 0) {
                $li.removeClass('check');
            }

            if ($item.isInViewport()) {
                if (id.match(/:/gm) != null) {
                    var string1 = id.split(':')[0];
                    var string2 = 'tab_' + id.split(':')[1];

                    $('#carouselNavigation .carousel-item').each(function () {
                        var carId = $(this).attr('id');

                        if (string1 === carId || string2 === carId) {
                            $(this).addClass('active');
                        } else {
                            $(this).removeClass('active');

                            if ($('#carouselNavigation .carousel-item.active').length < 1) {
                                $('#carouselNavigation .carousel-item').last().addClass('active');
                            } else if ($('#carouselNavigation .carousel-item.active').length > 1){
                                $('#carouselNavigation .carousel-item').last().removeClass('active');
                            }
                        }
                    });
                } else {
                    $('#carouselNavigation .carousel-item').each(function () {
                        var carId = $(this).attr('id');

                        if (id === carId) {
                            $(this).addClass('active');
                        } else {
                            $(this).removeClass('active');

                            if ($('#carouselNavigation .carousel-item.active').length < 1) {
                                $('#carouselNavigation .carousel-item').last().addClass('active');
                            }  else if ($('#carouselNavigation .carousel-item.active').length > 1){
                                $('#carouselNavigation .carousel-item').last().removeClass('active');
                            }
                        }
                    });
                }
            }
        })
    });
}

$.fn.isInViewport = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();

    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

function updateTabCount() {
    var count = $('li.check').length;
    $('#tabs-count').html(count);
}

//dynamic textarea height
$(document).on('click', ".estimate-data-row textarea", function () {
    $(this).on('input', function () {
        $(this).height(1);
        var totalHeight = $(this).prop('scrollHeight') - parseInt($(this).css('padding-top')) - parseInt($(this).css('padding-bottom'));
        $(this).height(totalHeight);
    });
});

$(function () {
    $('.carousel-btn').click(function () {
        $('#carouselNavigation').on('slid.bs.carousel', function () {
            var text = $('#carouselNavigation .carousel-item.active').attr('id');

            if (text.indexOf('-') > -1) {
                var textT = text.substr(0, text.lastIndexOf("-"))
            }
        });
    });

    $('#carouselNavigation a').click(function () {
        var aid = $(this).attr("href").replace('#', '');
        var h2 = $('h2[id="' + aid + '"]');

        $('html,body').animate({
                scrollTop: $(h2).offset().top - 50
            },
            'slow', 'swing');
    });

    if (window.location.href.indexOf("#messages") > -1) {
        $('#carouselNavigation').addClass('d-none');
    }

    if ($('.header-top > div').children().length < 1) {
        $('.header-top').addClass('d-none');
    }

    var headerH = $('header').outerHeight();

    $(window).on('load scroll', function () {
        var carousel = $('#carouselNavigation');

        if (carousel.length > 0) {
            $('.header-top').css('top', carousel.outerHeight() + 'px');
        }

        if ($(window).scrollTop() == 0) {
            // carousel.css('top', headerH + 'px');
            carousel.css('top', '46px');
            if (carousel.length > 0) {
                $('main > .container').css('padding-top', headerH + 'px');
            }
        } else {
            carousel.css('top', 0);
        }
    });

    function resizeLogic() {
        if ($(window).width() > 768) {
            var sideColumnHeight = $('.print-column').outerHeight();
            $('.application-content .tab-pane#view').css('min-height', sideColumnHeight + 100 + 'px');
        }

        if ($(window).width() < 769) {
            var carouselH = $('#carouselNavigation').outerHeight();
            $('main').css('padding-top', carouselH + 'px');

            $('.header-top').css('visibility', 'visible');

            var $collection = $('h2');
            if ($collection.length > 0) {
                $collection.each(function () {
                    var $item = $(this);
                    var id = $item.attr('id');

                    var headerTopH = $('.header-top').outerHeight();
                    var carouselH = $('#carouselNavigation').outerHeight();

                    var link = $('a[href="#' + id + '"]');
                    $(link).click(function () {
                        $('html, body').animate({
                            scrollTop: $item.offset().top - (headerTopH + carouselH)
                        }, 50);
                    });
                });
            }

        }
    }

    resizeLogic(); // on load
    $(window).resize(resizeLogic);

    var messengerTab = $('a[data-target="#messages"]');
    if (messengerTab.length > 0) {
        if (window.location.hash && window.location.hash === '#messages') {
            showMessages(messengerTab);
        }

        //ideta atskirai nes application view pjaunasi applications linkai su messenger tabu
        messengerTab.click(function () {
            showMessages(messengerTab);
        });

        function showMessages(link) {
            var activelink = link.closest('.nav-pills').find('.active');
            console.log(activelink);
            activelink.removeClass('active');
            link.addClass('active');
            $('#view').toggle();
            $('#messages').toggleClass('active');
            window.location.hash = '#messages';
        }
    }

    $('.conditional-fields label, .conditional-fields h2').each(function () {
        var span = $(this).text();

        if (span.match(/-\d/g)) {
            if (span.indexOf('-') > -1) {
                var text = span.substr(0, span.lastIndexOf("-"));

                $(this).text(text);
            }
        }

        $('.conditional-fields').css('visibility', 'visible');
    })

    $('td .accordion-button').each(function () {
        var accBody = $(this).parents('tr').next();

        if (accBody.hasClass('show')) {
            $(this).removeClass('collapsed');
        } else {
            $(this).addClass('collapsed');
        }
    })

    $('.accordion-header a.btn').click(function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    })

    if (window.location.href.indexOf("pagalba") < 0) {
        $('.side-menu').addClass('d-none');
        $('.structure-container').css('visibility', 'visible');
    } else {
        $('.page-content').addClass('col-md-9').removeClass('col-md-12');
        $('.structure-container').css('visibility', 'visible');
    }

    $('.curator-card .card-body').each(function () {
        var children = $(this).children();
        var width = 0;
        var cardW = $(this).outerWidth();


        $(children).each(function () {
            width += $(this).outerWidth(true);
        });

        if (width > cardW) {
            $(this).removeClass('flex-row').addClass('flex-column');
        }

        $(this).css('visibility', 'visible');
    })

    $('.application-form h2[id], .application-view h2[id]').each(function () {
        var idValue = $(this).attr('id');

        if (idValue.match(/:/gm) != null) {
            if (idValue.match(/:/gm).length === 1) {
                $(this).css('font-size', '25px');
            } else if (idValue.match(/:/gm).length === 2) {
                $(this).css('font-size', '22px');
            }

        }
    })

    $('.no-text .theme-title').click(function() {
        var firstChild =  $(this).siblings('.inner-list').find('.theme-child').first();
        var firstLink = firstChild.attr('href');

       $(this).attr('href', firstLink);
    })

});
// Custom confirmation modal
$(function () {
    var jBody = $('body');

    jBody.on('click', 'a[data-confirm-modal]', function (e, confirmed) {
        if (confirmed === true) {
            return true;
        }

        let currentBtn = e.target;

        let $link = $(this);
        let href = $link.data('src') || '';
        let hrefAttr = (href) ? ' href="' + href + '"' : '';
        let action = $link.data('action') || '';
        let actionAttr = (action) ? ' data-action="' + action + '"' : '';
        let classN = $link.data('class') || '';

        let dataAttr = '', className = '';

        var modalHtml =
            '<div class="modal fade modal-ajax-form" tabindex="-1" aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">'
            + '<div class="modal-dialog modal-dialog-centered">'
            + '<div class="modal-content">'
            + '<div class="modal-header">'
            + '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>'
            + '</div>'
            + '<div class="modal-body">'
            + '<img src="/Project/Modules/General/Admin/assets/images/icons/icon-info.svg"/>'
            + '<h5 class="modal-title">' + $link.data('confirm-modal') + '</h5>'
            + '</div>'
            + '<div class="modal-footer py-3">'
            + '<a' + hrefAttr + ' class="btn btn-primary btn-href' + ((!href) ? ' d-none' : className) + '"' + dataAttr + '>'
            + ($link.data('btn-ok') || 'OK') + '</a>'
            + '<a' + actionAttr + ' data-bs-dismiss="modal" aria-label="Close"  class="btn btn-action btn-primary  ' + classN + '' + ((!action) ? ' d-none' : className) + '"' + actionAttr + '>'
            + ($link.data('btn-ok') || 'OK') + '</a>'
            + '<button type="button" class="btn btn-primary close-modal" data-bs-dismiss="modal" aria-label="Close">Uždaryti</button>'
            + '</div>'
            + '</div>'
            + '</div>'
            + '</div>';

        let $modal = $(modalHtml);

        $(document).on("click", ".btn-action", function () {
            $(currentBtn).removeAttr('data-confirm-modal');
            $(currentBtn).addClass(classN);
            $(currentBtn).trigger('click');
        });

        $('body').append($modal);

        let modal_inst = new bootstrap.Modal($modal);
        modal_inst.show();

        $modal.modal({}).on('hidden.bs.modal', function () {
            $modal.remove();
        });

        return false;
    });
});


// $('body').on('click', 'a[data-eligible]', function (e) {
//     e.preventDefault();
//     var $button =  $(e.target);
//     var link = $button.attr('href');
//
//     $.post(link)
//         .done(function( data ) {
//             let modalBody = '';
//             if (typeof data.message === 'undefined' || data.message[0].type !== 'danger') {
//                 window.location.href = link;
//             }
//             if (data.message[0].text) {
//                 modalBody += '<img src="/Project/Modules/General/Admin/assets/images/icons/icon-'+ data.message[0].type +'.svg"/>' +
//                     '<h5 class="modal-title">'+data.message[0].text+'</h5>';
//                 let modal = modal_html(modalBody);
//                 var $modal = $(modal);
//                 $('body').append($modal);
//                 let bsModal = new bootstrap.Modal($modal[0], {});
//                 bsModal.show()
//             }
//         });
// })
//
// function modal_html(message) {
//     var modalHtml =
//         '<div class="modal fade modal-ajax-form" tabindex="-1" aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">'
//         + '<div class="modal-dialog modal-dialog-centered">'
//         + '<div class="modal-content">'
//         + '<div class="modal-header">'
//         + '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>'
//         +'</div>'
//         + '<div class="modal-body">'+message+'</div>'
//         +'<div class="modal-footer py-3">'
//         +'<button type="button" class="btn btn-primary close-modal" data-bs-dismiss="modal" aria-label="Close">Uždaryti</button>'
//         +'</div>'
//         + '</div>'
//         + '</div>'
//         + '</div>';
//
//     return modalHtml;
// };
function replaceUrlParam(url, paramName, paramValue) {
    //https://stackoverflow.com/a/49033367
    var href = new URL(url);
    href.searchParams.set(paramName, paramValue);
    return href.toString();

    //https://stackoverflow.com/a/20420424
    if (paramValue == null) {
        paramValue = '';
    }
    var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
    if (url.search(pattern) >= 0) {
        return url.replace(pattern, '$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/, '');
    return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
}

$('[data-table-orderable]').each(function (index, object) {
    var that = $(this);
    var columnName = that.data('table-orderable');
    var newUrlAsc = replaceUrlParam(window.location.href, 'ordering', that.data('table-orderable') + '%20asc');
    var newUrlDesc = replaceUrlParam(window.location.href, 'ordering', that.data('table-orderable') + '%20desc');

    var ordering = (new URL(window.location)).searchParams.get('ordering');
    var urlColumn, urlDirection;
    [urlColumn, urlDirection] = [];
    if (ordering) {
        ordering = decodeURI(ordering);
        [urlColumn, urlDirection] = ordering.split(' ');
    }

    if (index === 0 && !urlDirection) {
        urlColumn = columnName;
        urlDirection = 'asc';
    }
    that.children('div').append(`
            <span class="sorting-icons my-auto ps-1">
                <a href="${newUrlAsc}" class="d-inline ` + (columnName === urlColumn ? 'd-none' : null) + `"><i class="fas fa-sort"></i></a>
                <a href="${newUrlAsc}" class="d-inline ` + (urlColumn && columnName === urlColumn && urlDirection === 'desc' ? 'active' : 'd-none') + `"><i class="fas fa-sort-up"></i></a>
                <a href="${newUrlDesc}" class="d-inline ` + (urlColumn && columnName === urlColumn && urlDirection === 'asc' ? 'active' : 'd-none') + `"><i class="fas fa-sort-down"></i></a>
            </span>
        `);
    $(this).wrapInner('<div class="d-flex" />');
});